import { transparentize } from 'polished';

import { ToastMessageSettings } from './types';

export const toastMessageSettings: ToastMessageSettings = {
  componentVariants: {
    iconColor: {
      prop: 'iconColor',
      variants: {
        'dark-success': {
          color: 'success.light',
        },
        'dark-info': {
          color: 'primary.light',
        },
        'dark-warning': {
          color: 'danger.light',
        },
      },
    },
    colorVariant: {
      prop: 'colorVariant',
      variants: {
        dark: {
          background: (props) => transparentize(0.1, props.colors.black.main),
          boxShadow: '0px 12px 24px rgba(2, 11, 17, 0.15)',
          color: 'white.main',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        regular: {
          borderRadius: 3,
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 6,
          paddingRight: 6,
        },
      },
    },
  },
};
